export default function buildTree(nodes) {
  const nodeMap = new Map();
  const roots = [];

  nodes.forEach((node) => {
    node.children = [];
    nodeMap.set(node.id, node);
  });

  nodes.forEach((node) => {
    if (node.parentId) {
      const parent = nodeMap.get(node.parentId);
      if (parent) {
        parent.children.push(node);
      } else {
        // Optionally handle orphans
        roots.push(node);
      }
    } else {
      roots.push(node);
    }
  });

  return roots;
}
